/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/revokeCredential.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { REVOKE_CREDENTIAL } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IRevokeCredentialMethods extends IPluginMethodMap {
  getRevokeCredential(args: any): Promise<any>;
}

export interface RevokeCredentialProps {
  id: string;
}

export class RevokeCredentialService implements IAgentPlugin {
  readonly methods: IRevokeCredentialMethods;

  constructor() {
    this.methods = {
      getRevokeCredential: this.getRevokeCredential.bind(this),
    };
  }

  async getRevokeCredential(args: RevokeCredentialProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: REVOKE_CREDENTIAL,
          variables: {
            revokeCredentialId: args,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.revokeCredential?.message) {
          return {
            notification: notification?.revokeCredential,
          };
        }
      }
    } catch (err: any) {
      // console.log("error in revoke credential", err?.message);
      throw err;
    }
  }
}
